 /* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {
    addOnboardingFormType,
    editOnboardingFormType,
    getOnboardingFormsType,
} from "../../api/apiCall";
import { useAuth } from "../../auth/auth";
import { format } from "date-fns";
import { toast } from "react-toastify";
 
const OnboardingForms = () => {
    const {state} = useAuth();
    const [onboardingForms, setOnboardingForms] = useState<any>([]);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [modalMode, setModalMode] = useState<'add' | 'edit'>('add');
    const [currentOnboardingForm, setCurrentOnboardingForm] = useState<any>(null);
    const [onboardingFormName, setOnboardingFormName] = useState('');
    const [formError, setFormError] = useState('');

    const handleAddClick = () => {
        setModalMode('add');
        setOnboardingFormName('');
        setCurrentOnboardingForm(null);
        setFormError('');
        setIsDialogOpen(true);
    };

    const handleEditClick = (params: any) => {
        setModalMode('edit');
        setCurrentOnboardingForm(params.row);
        setOnboardingFormName(params.row.name);
        setFormError('');
        setIsDialogOpen(true);
    };

    const handleDialogClose = () => {
        setIsDialogOpen(false);
        setOnboardingFormName('');
        setCurrentOnboardingForm(null);
        setFormError('');
    };

    const handleSubmit = async () => {
        if (!onboardingFormName.trim()) {
            setFormError('Onboarding form name cannot be empty');
            return;
        }

        if (modalMode === 'add') {
            const response = await addOnboardingFormType(state.user?.token, onboardingFormName);
            if (response) {
                toast.success('Added onboarding form successfully');
                getAllOnboardingForms();
                handleDialogClose();
            } else {
                toast.error('Something went wrong!');
            }
        } else {
            if (currentOnboardingForm) {
                const response = await editOnboardingFormType(state.user?.token, currentOnboardingForm.id, onboardingFormName);
                if (response) {
                    toast.success('Onboarding form updated successfully');
                    getAllOnboardingForms();
                    handleDialogClose();
                } else {
                    toast.error('Something went wrong!');
                }
            }
        }
    };

    const getAllOnboardingForms = async () => {
        const response = await getOnboardingFormsType(state.user?.token);
        setOnboardingForms(response.data);
    }
 
    useEffect(() => {
        getAllOnboardingForms();
    }, []);
 
    const columns: any = [
        {
            field: "name",
            headerName: "Onboarding Forms",
            flex: 0.8,
            renderCell: (params: any) => (
                <div>{params.row.name}</div>
            ),
        },
        {
            field: "createdDate",
            headerName: "Added Date",
            align: 'center',
            headerAlign: 'center',
            flex: 0.5,
            renderCell: (params: any) => (
                <div>
                    {format(new Date(params.row.createdDate || Date.now()), 'dd/MM/yyyy')}
                </div>
            ),
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 0.3,
            renderCell: (params: any) => (
                <div>
                    <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => handleEditClick(params)}
                        style={{ marginRight: 8 }}
                    >
                        Edit
                    </Button>
                </div>
            )
        }
    ];
 
    return (
        <Box sx={{ 
            p: 1,
            height: '100%',
            minHeight: '100vh'
        }}>
            <Paper 
                elevation={0} 
                sx={{ 
                    p: 3, 
                    borderRadius: '16px',
                    backgroundColor: '#ffffff',
                    maxWidth: '1200px',
                    margin: '0 auto'
                }}
            >
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'flex-end', 
                    alignItems: 'center',
                    mb: 3 
                }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddClick}
                        style={{boxShadow: 'none'}}
                    >
                        Add Onboarding Form
                    </Button>
                </Box>
 
                <Box
                    sx={{
                        width: "100%",
                        height: '740px',
                        margin: "0 auto",
                        "@media (max-width: 800px)": {
                            overflowX: "auto",
                            margin: 1,
                            minWidth: "95%",
                        },
                    }}
                >
                     <DataGrid
                        rows={onboardingForms}
                        columns={columns}
                        disableRowSelectionOnClick
                        sx={{
                            "@media (max-width: 700px)": {
                                minWidth: "100%",
                            },
                            "& .MuiDataGrid-columnHeader": {
                                color: "#333",
                                fontWeight: "bold",
                                fontSize: 15,
                                backgroundColor: '#f0f0f0',
                            },
                            "& .MuiDataGrid-columnHeaderTitle": {
                                fontWeight: "bold",
                            },
                            "& .MuiDataGrid-row:hover": {
                                backgroundColor: "#f1f1f1",
                            },
                        }}
                    />
                </Box>
            </Paper>
 
            <Dialog 
                open={isDialogOpen} 
                onClose={handleDialogClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>
                    {modalMode === 'add' ? 'Add New Onboarding Form' : 'Edit Onboarding Form'}
                </DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Onboarding Form Name"
                        type="text"
                        fullWidth
                        size="small"
                        variant="outlined"
                        value={onboardingFormName}
                        onChange={(e) => {
                            setOnboardingFormName(e.target.value);
                            setFormError('');
                        }}
                        error={!!formError}
                        helperText={formError}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleSubmit();
                            }
                        }}
                        sx={{ mt: 2, mb: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="inherit">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} color="primary" variant="contained" style={{boxShadow: 'none'}}>
                        {modalMode === 'add' ? 'Add' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};
 
export default OnboardingForms;
 